<template>
  <Breadcrumbs
      title="Distributor Target History"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Target ', path: '/distributor-target-history' },
      { label: 'Distributor Target History', path: '/distributor-target-history' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <sampleForm/>
    </div>
  </div>
</template>

<script>
import sampleForm from './target_history_form.vue'
export default {
  name: 'indexList',
  components: {
    sampleForm,
  },
}
</script>